var map = {
	"./task-cant-complete-selected.svg": 435,
	"./task-completed-selected.svg": 436,
	"./task-rescheduled-selected.svg": 437
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 867;



//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/task\-.*\-selected\.svg$
// module id = 867
// module chunks = 0